import { Autocomplete, AutocompleteChangeDetails, AutocompleteInputChangeReason, Button, Grid, TextField, Tooltip } from '@mui/material';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { resetExpenseInput, setExpenseInputExpand, setSelectedExpenseId, setTriggerFocusCompanyNameInput, setExpenseInput, setItems, setType, setMonth, setExpenseItems, setAmount } from './reducers/ExpenseInputReducer';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import { ExpenseInputSelector } from './reducers/ExpenseInputReducer';
import ExpenseApi from './api/ExpenseApi';
import { ExpenseSearchSelector, setTriggerExpenseSearch } from './reducers/ExpenseSearchReducer';
import ExpenseModel from './models/ExpenseModel';
import NumberFormatCustom from '../NumberFormatCustom/NumberFormatCustom';

export const Months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const ExpenseInput: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const expenseInputViewData = useSelector(ExpenseInputSelector);
    const ExpenseSearchData = useSelector(ExpenseSearchSelector);

    useEffect(() => {
        if (expenseInputViewData.triggerSave > 0) {
            save();
        }
    }, [expenseInputViewData.triggerSave]);

    let loadExpenseItems = (callBack: () => void) => {
        ExpenseApi.GetExpenseItems().then((response: BaseResponse<string[]>) => {
            if (response.success) {
                dispatch(setExpenseItems(response.data));

                dispatch(showLoading(false));

                callBack();

            } else {
                Utility.Alert.Error(response.message);
                dispatch(showLoading(false));
            }
        }).catch((error) => {
            Utility.Alert.Error(error);
            dispatch(showLoading(false));
        })
    }

    useEffect(() => {
        dispatch(showLoading(true));

        loadExpenseItems(() => {

        });
    }, []);

    useEffect(() => {
        if (expenseInputViewData.triggerRefreshInput > 0) {
            refreshInput();
        }
    }, [expenseInputViewData.triggerRefreshInput]);

    const refreshInput = () => {
        dispatch(resetExpenseInput());
        dispatch(setSelectedExpenseId(""));
        dispatch(setTriggerFocusCompanyNameInput((new Date()).getTime()));
    }

    useEffect(() => {
        if (expenseInputViewData.selectedExpenseId.length > 0) {
            selectExpenseById(expenseInputViewData.selectedExpenseId);
        }
    }, [expenseInputViewData.selectedExpenseId])

    const selectExpenseById = (id: string) => {
        dispatch(showLoading(true));
        ExpenseApi.GetById({
            id: id
        }).then((response: BaseResponse<ExpenseModel>) => {
            if (response.success) {
                dispatch(setExpenseInput(response.data));

                dispatch(showLoading(false));

            } else {
                Utility.Alert.Error(response.message);
                dispatch(showLoading(false));
            }
        }).catch((error) => {
            Utility.Alert.Error(error);
            dispatch(showLoading(false));
        })
    };

    const save = () => {
        try {
            validate();

            ExpenseApi.Save(expenseInputViewData.input)
                .then((response: BaseResponse<ExpenseModel>) => {
                    if (response.success) {
                        if (expenseInputViewData.input.id.length === 0) {
                            Utility.Alert.Success("Expense added successful");
                        } else {
                            Utility.Alert.Success("Expense updated successful");
                        }

                        refreshInput();

                        loadExpenseItems(() => {
                            dispatch(setTriggerExpenseSearch(new Date().getTime()));
                        });
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                })
                .catch((error) => {
                    Utility.Alert.Error(error);
                });
        } catch (error) {
            Utility.Alert.Error(error);
        }
    }

    const validate = () => {
        if (expenseInputViewData.input.items.length === 0) {
            throw "Items is required";
        }

        if (expenseInputViewData.input.type.length === 0) {
            throw "Type is required";
        }
    }

    return (
        <>
            {
                <CustomAccordion
                    title="Input"
                    defaultOpen={true}
                    className="top-quick-input"
                    open={expenseInputViewData.ExpenseInputExpand}
                    onOpenChange={(isOpen: boolean) => {
                        dispatch(setExpenseInputExpand(isOpen));
                    }}
                >
                    <Grid container>
                        <Grid item lg={3} xs={12}>
                            <Grid container>
                                <Grid xs={10} lg={9}>
                                    <Autocomplete
                                        className='cargo-input-component'
                                        freeSolo={true}
                                        options={Months}
                                        renderInput={(params) => <TextField {...params} label="Month" />}
                                        value={expenseInputViewData.input.month}
                                        onChange={(event: React.SyntheticEvent, value: string | null, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                            dispatch(setMonth(value ? value : ""));
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} lg={3}>
                                    <Tooltip title="Reset (Alt + R)">
                                        <Button
                                            className="clear-input-button"
                                            tabIndex={-1}
                                            color="success"
                                            variant="contained"
                                            onClick={() => {
                                                refreshInput();
                                            }}
                                        >
                                            <i className="fa fa-refresh" aria-hidden="true"></i>
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item lg={3} xs={12}>
                            <Autocomplete
                                className='cargo-input-component'
                                freeSolo={true}
                                options={["Estimate Expenses", "Actual Expenses"]}
                                renderInput={(params) => <TextField {...params} label="Type" />}
                                value={expenseInputViewData.input.type}
                                onChange={(event: React.SyntheticEvent, value: string | null, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                    dispatch(setType(value ? value : ""));
                                }}
                            />
                        </Grid>
                        <Grid item lg={3} xs={12}>
                            <Autocomplete
                                className='cargo-input-component'
                                freeSolo={true}
                                options={expenseInputViewData.expenseItems}
                                renderInput={(params) => <TextField {...params} label="Items" />}
                                value={expenseInputViewData.input.items}
                                onChange={(event: React.SyntheticEvent, value: string | null, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                    dispatch(setItems(value ? value : ""));
                                }}
                                onInputChange={(event: React.SyntheticEvent<Element, Event>, value: string, reason: AutocompleteInputChangeReason) => {
                                    dispatch(setItems(value ? value : ""));
                                }}
                            />
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="Amount"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={expenseInputViewData.input.amount ? expenseInputViewData.input.amount : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setAmount(value));
                                }}
                            >
                            </TextField>
                        </Grid>
                        <Grid item lg={1} xs={12}>
                            <Tooltip title="Alt + S">
                                <Button
                                    onClick={save}
                                    variant="outlined"
                                >
                                    Save (s)
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </CustomAccordion>
            }
        </>
    )
};

export default ExpenseInput;